<template>
  <mu-card-header
    style="display: flex;align-items:center"
    :title="userinfo.username"
    :sub-title="userinfo.mobile"
  >
    <mu-avatar slot="avatar">
      <img :src="userinfo.userhead || defaultHead" />
    </mu-avatar>
  </mu-card-header>
</template>
<script>
import head from "@/assets/image/avatar.png";
import store from "store";
export default {
  data() {
    return {
      defaultHead: head,
      userinfo: {
        userhead: "",
        username: "",
        mobile: "",
      },
    };
  },
  mounted() {
    this.userinfo.username = store.get("adminuser").adminuser.realName;
    this.userinfo.userhead = store.get("adminuser").adminuser.headImage;
    this.userinfo.mobile = store.get("adminuser").adminuser.mobile;
  },
};
</script>
<style lang="scss" scoped>
::v-deep .mu-avatar {
  width: 1.28rem !important;
  height: 1.28rem !important;
}
::v-deep .mu-card-title {
  font-size: 0.5rem;
}
::v-deep .mu-card-sub-title {
  font-size: 0.4rem;
}
</style>
